/**
 * Strings of DM and group DM calls (2026-11-01): the Call button, the call
 * band at the top of a DM, the incoming call card and its notification, and
 * the call's line in the DM's history (Discord's wording).
 */
import type { Dict } from './core';

export const callsEn: Dict = {
  // Settings > Sounds
  'ns.snd.k.call': 'A call rings you, and the ringback while you call',
  // the header
  'call.start': 'Start voice call',
  'call.join': 'Join call',
  'call.off': 'Calls are turned off by the admins.',
  'call.refused': "You can't call here right now.",
  'call.couldNot': "Couldn't join the call: {why}",
  'call.ringFailed': "Couldn't ring them. Try again in a moment.",
  'call.ended': 'The call ended.',
  // the call band
  'call.band': 'Call',
  'call.controls': 'Call controls',
  'call.leave': 'Leave call',
  'call.connecting': 'Connecting…',
  'call.count': { one: '{n} in the call', other: '{n} in the call' },
  'call.waiting': 'Waiting for others to join',
  'call.ringing': 'Ringing…',
  'call.ring': 'Ring',
  'call.ringTip': 'Ring {name}',
  'call.notJoined': 'Not in the call',
  // the incoming call card and its notification
  'call.in.stack': 'Incoming calls',
  'call.in.dm': 'Incoming call',
  'call.in.group': 'Incoming group call',
  'call.in.accept': 'Accept',
  'call.in.decline': 'Decline',
  'call.os.dm': 'Incoming call. Open the app to answer.',
  'call.os.group': 'Incoming group call. Open the app to answer.',
  // the call's line in the history
  'call.msg.started': '{name} started a call.',
  'call.msg.lasted': '{name} started a call that lasted {d}.',
  'call.msg.missedLasted': 'You missed a call from {name} that lasted {d}.',
  'call.dur.seconds': 'a few seconds',
  'call.dur.minutes': { one: 'a minute', other: '{n} minutes' },
  'call.dur.hours': { one: 'an hour', other: '{n} hours' },
};
